import React, { Component } from 'react';
import Modal from '../../../components/modals';
import Select from 'react-select';
import { gql } from '@apollo/client';
import _ from 'lodash';
import { toast } from 'react-toastify';
import ProjectsGraphQl from '../../../../controllers/projectsGraphQl';
import { ReactComponent as Delete } from '../../../../assets/svg/delete.svg';
const getEquipment = gql`
	query EquipmentList($eqIdentifier: [String!]!) {
		equipmentInfo(eqIdentifier: $eqIdentifier) {
			id
			qrCode
			ownerType
			ownerId
			type
			comment {
				_id
				comment
				createdAt
				createdBy
			}
			model
			description
			manufacturer
			manufacturerId
			status
			lastUsedBy {
				tenantId
				workspaceId
				projectId
				projectName
				projectSlNo
				eventId
				eventName
				eventSlNo
				userId
				userName
				usedAt
			}
			createdBy
			createdAt
			updatedBy
			updatedAt
			branch {
				_id
				branchId
			}
		}
	}
`;
const assignEquipmentMutation = gql`
	mutation RootMutation($qrCodes: [String!]!, $assignedTo: ID!, $eventId: ID, $projectId: ID) {
		assignEquipment(
			qrCodes: $qrCodes
			assignedTo: $assignedTo
			eventId: $eventId
			projectId: $projectId
		) {
			message
		}
	}
`;
class AssignEquipment extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			disabledBtn: false,
			crewOptions: [],
			assignedCrew: null,
			qrCode: '',
			equipments: [],
			qrCodeError: false,
			qrCodeDuplicate: false,
			step: 1,
			isCheckedConfiramtion: false,
		};
		this.timeout = 0;
	}
	componentDidMount = () => {
		let crew = this.props.crew;
		let arr = [];
		_.forEach(crew, (item, key) => {
			arr.push({ value: item.id, label: item.name });
		});

		this.setState({
			crewOptions: arr,
		});
	};
	handleCloseModal = () => {
		this.props.handleClose();
	};
	handleEditCrewName = (e) => {
		this.setState({
			assignedCrew: e.value,
		});
	};
	handleEventChange = (e, name) => {
		this.setState(
			{
				qrCode: e.target.value,
				qrCodeError: false,
				qrCodeDuplicate: false,
			},
			async () => {
				if (
					e.target.value !== '' &&
					e.target.value.length == 8 &&
					_.size(
						_.filter(this.state.equipments, {
							qrCode: e.target.value,
						}),
					) == 0
				) {
					let json = { eqIdentifier: e.target.value };
					await this.getEquipmentInfo(getEquipment, json);
				} else {
					if (
						_.size(
							_.filter(this.state.equipments, {
								qrCode: e.target.value,
							}),
						) > 0
					) {
						this.setState({
							qrCodeDuplicate: true,
						});
					}
				}
			},
		);
	};
	isDisabled = () => {
		if (this.state.step == 1) {
			if (_.size(this.state.equipments) == 0 || this.state.assignedCrew == null) {
				return true;
			} else {
				return false;
			}
		}
		if (this.state.step == 2) {
			if (this.state.isCheckedConfiramtion == false) {
				return true;
			} else {
				return false;
			}
		}
	};
	handleAssignEquipment = async (e) => {
		let eventId = this.props.match.params.shootID;
		let projectId = this.props.match.params.projectID;
		let qrCodes = [];
		_.forEach(this.state.equipments, (equipment, key) => {
			qrCodes.push(equipment.qrCode);
		});
		let json = {
			qrCodes: qrCodes,
			assignedTo: this.state.assignedCrew,
			eventId,
			projectId,
		};

		let resp = await this.assignEquipment(assignEquipmentMutation, json);

		if (resp == false) {
			//this.handleCloseModal();
			toast.error('Cannot assign equipment to non verified users!', {
				position: 'top-right',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: 'light',
			});
		} else {
			this.handleCloseModal();
			toast.success('Equipment Assigned Successfully!', {
				position: 'top-right',
				autoClose: 500,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: 'light',
			});
		}
	};
	deleteItem = (e, qrCode) => {
		let equipments = [...this.state.equipments];
		this.setState({
			equipments: _.filter(equipments, function (o) {
				return o.qrCode !== qrCode;
			}),
		});
	};
	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'right-add'}
			>
				{' '}
				<div className="project-add-edit-popup">
					<div className="project-add-edit-popup-header">
						<span className="header-title">
							{this.props.projectTitle} &#x2022; {this.props.eventTitle}
						</span>
					</div>
					<div className="project-add-edit-popup-subheader shoot-subheader">
						<a className="sub-header-title">Assign Equipment</a>
					</div>
					<div className="project-add-edit-popup-body">
						<div className="project-add-edit-popup-body-item equipment-assign-popup">
							<h4>Equipment List</h4>
							<div className="table">
								<div className="hdd-item ">
									<div className="column column-20w">
										<span>qr code</span>
										<span>description</span>
										<span>Status</span>
										<span></span>
									</div>
									{_.map(this.state.equipments, (equipment, key) => {
										return (
											<div className="hitem column-20w">
												<span
													style={{
														color:
															equipment.status === 'busy'
																? '#FDB946'
																: '',
													}}
												>
													{equipment.qrCode}
												</span>
												<span
													style={{
														color:
															equipment.status === 'busy'
																? '#FDB946'
																: '',
													}}
												>
													{equipment.description}
												</span>
												<span>{equipment.status}</span>
												<span
													onClick={(e) =>
														this.deleteItem(e, equipment.qrCode)
													}
												>
													<Delete />
												</span>
											</div>
										);
									})}

									<div
										className="hitem column-20w"
										style={{
											display: 'flex',
											flexDirection: 'column',
										}}
									>
										<input
											value={this.state.qrCode}
											placeholder="Type QR Code"
											onChange={(e) => this.handleEventChange(e, 'qrCode')}
										/>
										{this.state.qrCodeError ? <p>Equipment not found</p> : ''}
										{this.state.qrCodeDuplicate ? (
											<p>Equipment already scanned</p>
										) : (
											''
										)}
									</div>
								</div>
							</div>
						</div>
						<div className="project-add-edit-popup-body-item">
							<div
								className="floating-select-container"
								style={{ marginTop: '20px' }}
							>
								<label>Assign To</label>
								<Select
									className={`cost-select-container zIndex3 w-100p `}
									classNamePrefix="cost-select"
									onChange={(e) => this.handleEditCrewName(e)}
									isSearchable={true}
									options={this.state.crewOptions}
									value={
										_.filter(this.state.crewOptions, {
											value: this.state.assignedCrew,
										})[0]
									}
								/>
							</div>
						</div>
						{this.state.step == 2 ? (
							<>
								{_.map(
									_.filter(this.state.equipments, {
										status: 'busy',
									}),
									(conflictEquipment, key) => {
										if (
											conflictEquipment.lastUsedBy.projectId ===
												this.props.match.params.projectID &&
											conflictEquipment.lastUsedBy.eventId ===
												this.props.match.params.shootID
										)
											return (
												<div className="project-add-edit-popup-body-item yellow-warning">
													{conflictEquipment.qrCode} is previously
													assigned to{' '}
													{conflictEquipment.lastUsedBy.userName}. By
													continuing this will be reassigned to{' '}
													{
														_.filter(this.state.crewOptions, {
															value: this.state.assignedCrew,
														})[0].label
													}
												</div>
											);
									},
								)}
							</>
						) : (
							''
						)}
						{this.state.step == 2 ? (
							<div className="project-add-edit-popup-body-item">
								<label className={'download-label'}>
									<div className={'round'}>
										<input
											className={'radio-input'}
											type={'checkbox'}
											id={'checkbox2'}
											checked={this.state.isCheckedConfiramtion}
											onClick={() =>
												this.setState({
													isCheckedConfiramtion:
														!this.state.isCheckedConfiramtion,
												})
											}
										/>
										<label for={'checkbox2'}></label>
									</div>
									I confirm that all the information mentioned above is accurate.
								</label>
							</div>
						) : (
							''
						)}
					</div>

					<div className="bottom-popup-action-container">
						<span className="cancel-btn" onClick={() => this.handleCloseModal()}>
							Cancel
						</span>
						{this.state.disabledBtn ? (
							''
						) : (
							<span
								className={
									this.isDisabled() ? 'add-edit-btn disabled' : 'add-edit-btn'
								}
								onClick={(e) => {
									if (!this.isDisabled()) {
										if (this.state.step == 1) {
											this.setState({ step: 2 });
										} else {
											this.handleAssignEquipment(e);
										}
									}
								}}
							>
								<span>{this.state.step == 1 ? 'Next' : 'Assign'}</span>
							</span>
						)}
					</div>
				</div>
			</Modal>
		);
	}
}

export default AssignEquipment;
